import { useEffect } from 'react'

interface StructuredDataProps {
  type: 'WebApplication' | 'Organization' | 'WebPage'
}

export function StructuredData({ type }: StructuredDataProps) {
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    
    let data = {}
    
    if (type === 'WebApplication') {
      data = {
        '@context': 'https://schema.org',
        '@type': 'WebApplication',
        name: 'Ordelio',
        description: 'Routine-friendly list and checklist app with offline support, online collaboration, and custom store routes',
        applicationCategory: 'LifestyleApplication',
        operatingSystem: 'Web Browser',
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'USD'
        },
        featureList: [
          'Offline-first functionality',
          'Online collaboration when connected',
          'Item history and suggestions',
          'Multi-device sync',
          'Custom store routes',
          'Reusable checklists for repeatable routines'
        ],
        screenshot: '/icon.svg'
        // Note: aggregateRating removed - should be added when real user ratings are available
      }
    } else if (type === 'Organization') {
      data = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Ordelio',
        url: 'https://ordelio.com',
        logo: 'https://ordelio.com/icon.svg',
        description: 'List and checklist application'
      }
    } else if (type === 'WebPage') {
      data = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Ordelio - Shopping Lists',
        description: 'Create repeatable lists that work offline, organize by your preferred order, and share when online',
        url: 'https://ordelio.com'
      }
    }
    
    script.text = JSON.stringify(data)
    document.head.appendChild(script)
    
    return () => {
      document.head.removeChild(script)
    }
  }, [type])
  
  return null
}
